import React from "react";
import { Box } from "braid-design-system";

// Single generic fallback shown when an item has no image in
// pos_item_resources - never a stand-in for a real per-item photo.
const DEFAULT_ICON = "📦";

interface ItemThumbnailProps {
    imageUrl?: string | null;
    alt: string;
    size: number;
    fontSize?: number;
    fallbackIcon?: string;
}

const ItemThumbnail: React.FC<ItemThumbnailProps> = ({ imageUrl, alt, size, fontSize, fallbackIcon = DEFAULT_ICON }) => (
    <Box
        background="neutralLight"
        borderRadius="standard"
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{ width: size, height: size, fontSize: fontSize ?? Math.round(size * 0.5), flexShrink: 0, overflow: "hidden" }}
    >
        {imageUrl ? (
            <img src={imageUrl} alt={alt} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        ) : (
            fallbackIcon
        )}
    </Box>
);

export default ItemThumbnail;
